// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7f73040","581":"ec542a51"}[chunkId] + ".chunk.js";
};